// src/App.js
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';
import './App.css';
import AppTheme from './theme/AppTheme';
import CssBaseline from '@mui/material/CssBaseline';
import Features from './components/Features';
import MasonryImageList from './components/MasonryImageList';
import bgImg from './images/pexels-mikhail-nilov-9242167.jpg'
import Testimonials from './components/Testimonials';
import { Box } from '@mui/material';
import { SiteContentProvider } from './context/SiteContentContext';
function App(props) {
    return (
        <AppTheme {...props}>
            <SiteContentProvider>
                <div className="App">
                    <div id="hero" />

                    <CssBaseline enableColorScheme />
                    <Header />

                    <main>
                        <Hero />

                        <div id="services" />
                        <Features />

                        <div id="gallery" />
                        <MasonryImageList />
                        <div id="about" />
                        <AboutUs />
                        <Testimonials />
                        <Box display="flex" justifyContent="center" bgcolor="#f4f6f8" sx={{
                            backgroundRepeat: 'no-repeat',
                            backgroundImage: `url(${bgImg})`, backgroundSize: 'cover'
                        }}>
                            <div id="contact" />
                          <Box display="flex" flexDirection="column" width="100%" alignItems="center">
    <ContactForm />
    <Footer />
</Box>

                        </Box>
                    </main>
                </div >
            </SiteContentProvider>
        </AppTheme >
    );
}

export default App;
